import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { useLenis } from "@/hooks/useLenis";
import { useClickTracking } from "@/hooks/useClickTracking";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import StudioPage from "@/pages/StudioPage";
import WorksPage from "@/pages/WorksPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

const SiteLayout = ({ children }) => {
    useClickTracking();
    return (
        <div className="grain flex min-h-screen flex-col bg-ivory font-sans text-ink antialiased">
            <Navbar />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
};

const SiteRoutes = () => (
    <SiteLayout>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/studio" element={<StudioPage />} />
            <Route path="/works" element={<WorksPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    </SiteLayout>
);

function App() {
    useLenis();

    return (
        <MotionConfig reducedMotion="user">
            <AuthProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                        <Route path="/*" element={<SiteRoutes />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </MotionConfig>
    );
}

export default App;
